// UI
import { Button } from "@/components/Button"
import { DialogWrapper } from "@/components/dialogs/DialogWrapper"

// Icons
import { XIcon } from "@/lib/icons"

/**
 * ProjectTypeSolarLeaseInfo
 * @returns
 */
export function ProjectTypeSolarLeaseInfo({
	onClose,
}: {
	onClose: () => void
}) {
	const EXTERNAL_URL_SOLARLEASE_INFO =
		"https://financiering.zonhub.com/nl/lease/"

	return (
		<DialogWrapper>
			<div className="flex items-start justify-between rounded-t border-b p-5 dark:border-gray-600">
				<h3 className="text-xl font-semibold text-gray-900 dark:text-white lg:text-2xl">
					Zonhub Lease
				</h3>
				<button
					onClick={() => onClose()}
					type="button"
					className="ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white"
					data-modal-toggle="default-modal"
				>
					<XIcon width={24} className="text-2xl text-gray-400" />
				</button>
			</div>

			<div className="space-y-6 p-6">
				<p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
					Zonhub Lease is de financial lease oplossing van Zonhub voor
					duurzame energieprojecten (o.a. zon en batterij) vanaf
					25.000 euro. Bij deze financieringsvorm ben je direct
					economisch eigenaar van het duurzaam energiesysteem. Wij
					betalen de aanschafkosten van het systeem. Zo heb jij geen
					investeringskosten en blijft jouw werkkapitaal beschikbaar
					voor je eigen bedrijf. Direct vanaf de start profiteer je
					van lagere energiekosten en fiscale voordelen. Zonhub Lease
					bieden we aan voor zonne-energieprojecten op basis van de
					SDE-regeling en de salderingsregeling en voor batterijen,
					los of in combinatie met het zon-PV systeem.
				</p>
			</div>

			<div className="flex flex-col items-center space-x-2 rounded-b border-t border-gray-200 p-6 dark:border-gray-600">
				{/** Show either custom or default NO button */}
				<Button
					onClick={() =>
						(window.location.href = EXTERNAL_URL_SOLARLEASE_INFO)
					}
				>
					Meer informatie over Zonlease
				</Button>
			</div>
		</DialogWrapper>
	)
}
